function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
require('@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css');
import { bem } from 'scripts/util';
var MapboxGeocoder = require('@mapbox/mapbox-gl-geocoder');
import MapBoxResetControl from './MapBoxResetControl';
import turf from 'turf';

/**
 * TODO
 *
 * custom data binding
 * https://dev.to/proticm/vanilla-js-data-binding-with-classes-from-scratch-48b1
 */
var Locator = /*#__PURE__*/function () {
  function Locator(mapEl) {
    _classCallCheck(this, Locator);
    this.mapEl = mapEl;
    this.map = null;
    this.popupTemplate = document.getElementById('popup-template');
    this.setupMap();
  }
  return _createClass(Locator, [{
    key: "setupMap",
    value: function setupMap() {
      var _this = this;
      mapboxgl.accessToken = 'pk.eyJ1IjoicG93ZXJhZ2VuY3kiLCJhIjoiY2s4NHB4OXNzMDRteTNsbnptZmhtZWhmaSJ9.Bvzx3xZik2eFO7YlmrvGdg';
      this.map = new mapboxgl.Map({
        container: 'locator-map',
        style: 'mapbox://styles/poweragency/ck84rc8zt066y1io0ndev1aob',
        center: [-98.420679, 37.772537],
        zoom: 3.5,
        minZoom: 3.5
      });

      // @see MapBoxResetControl.js
      this.map.resetView = {
        center: [-98.420679, 37.772537],
        zoom: 3.5
      };
      this.map.addControl(new mapboxgl.NavigationControl({
        showCompass: false
      }), 'top-right');
      var geocoder = new MapboxGeocoder({
        accessToken: window.mapboxgl.accessToken,
        mapboxgl: mapboxgl,
        countries: 'us',
        placeholder: 'Search by zip or city',
        marker: false,
        // flyTo: true,
        flyTo: {
          speed: 2
        }
      });
      this.map.addControl(geocoder, 'top-left');
      geocoder.on('error', function (e) {
        return alert('There was an error processing your location.');
      });
      geocoder.on('result', function (e) {
        return _this.handleMapGeocode(e);
      });
      var geolocator = new mapboxgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true
        },
        fitBoundsOptions: {
          maxZoom: 10
        },
        showAccuracyCircle: false,
        trackUserLocation: false
      });
      geolocator.on('geolocate', function (e) {
        console.log(e);
        window.dataLayer.push({
          event: 'locator_geolocate'
        });
      });
      this.map.addControl(geolocator, 'top-left');
      this.map.addControl(new MapBoxResetControl(), 'top-left');
      this.map.on('load', function () {
        _this.map.on('wheel', _this.disableMapMouseWheel);
        _this.map.addSource('dealers', window.mapSource);
        _this.map.loadImage(window.markerIcon, function (e, img) {
          return _this.map.addImage('marsh-marker', img);
        });
        _this.map.addLayer({
          id: 'dealers',
          type: 'symbol',
          source: 'dealers',
          style: 'basic-v8',
          layout: {
            'icon-image': 'marsh-marker',
            'icon-size': 0.4,
            'icon-allow-overlap': true
          }
        });
        _this.map.on('click', 'dealers', function (e) {
          _this.map.flyTo({
            center: e.features[0].geometry.coordinates,
            zoom: 12
          });
          _this.addMapPopup(e);
        });
        _this.map.on('mouseenter', 'dealers', function (e) {
          return _this.setMapCursor('pointer');
        });
        _this.map.on('mouseleave', 'dealers', function (e) {
          return _this.setMapCursor('');
        });
      });
    }
  }, {
    key: "disableMapMouseWheel",
    value: function disableMapMouseWheel(e) {
      if (e.originalEvent.ctrlKey || e.originalEvent.metaKey || e.originalEvent.altKey || e.originalEvent.shiftKey) return;
      e.preventDefault();
    }
  }, {
    key: "setMapCursor",
    value: function setMapCursor() {
      var cursor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.map.getCanvas().style.cursor = cursor;
    }
  }, {
    key: "addMapPopup",
    value: function addMapPopup(e) {
      var pin = e.features[0];
      var coordinates = pin.geometry.coordinates.slice();
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }
      window.dataLayer.push({
        event: 'locator_pin_open',
        pin_name: pin.properties.title,
        pin_postal: pin.properties.postal
      });
      var popup = new mapboxgl.Popup().setLngLat(coordinates).setHTML(this.generatePopupHtml(pin.properties)).addTo(this.map);
      popup.on('close', function (evt) {
        return window.dataLayer.push({
          event: 'locator_pin_close',
          pin_name: pin.properties.title,
          pin_postal: pin.properties.postal
        });
      });
    }
  }, {
    key: "generatePopupHtml",
    value: function generatePopupHtml(props) {
      var clone = this.popupTemplate.content.cloneNode(true);
      clone.children[0].innerHTML = clone.children[0].innerHTML.replace(/\%TITLE\%/g, props.title).replace(/\%STREET\%/g, props.street).replace(/\%CITY\%/g, props.city).replace(/\%STATE\%/g, props.state).replace(/\%POSTAL\%/g, props.postal).replace(/\%PHONE\%/g, props.phone).replace(/\%WEBSITE\%/g, props.website);
      return clone.children[0].outerHTML;
    }
  }, {
    key: "handleMapGeocode",
    value: function handleMapGeocode(e) {
      var _this2 = this;
      this.map.dragPan.enable();
      window.dataLayer.push({
        'event': 'locator_geocode',
        'query_type': e.result.place_type[0],
        'query_text': e.result.text,
        'result': e.result.place_name
      });
      window.mapSource.data.features.forEach(function (location) {
        var dist = turf.distance(e.result.geometry, location.geometry, 'miles');
        dist = Math.round((dist + Number.EPSILON) * 100) / 100;
        location.properties.distance = Math.round((dist + Number.EPSILON) * 100) / 100;
      });
      window.mapSource.data.features = window.mapSource.data.features.sort(function (a, b) {
        return a.properties.distance - b.properties.distance;
      });
      this.map.once('moveend', function () {
        var bounds = _this2.map.getBounds();
        bounds.extend(window.mapSource.data.features[0].geometry.coordinates);
        // bounds.extend(window.mapSource.data.features[1].geometry.coordinates)
        _this2.map.fitBounds(bounds, {
          padding: 100
        });
      });
      var bounds = this.map.getBounds();
      bounds.extend(e.result.geometry.coordinates);
      bounds.extend(window.mapSource.features[0].geometry.coordinates);
      this.map.flyTo(bounds);
      this.map.fitBounds(bounds, {
        padding: 100
      });
    }
  }]);
}();
export { Locator as default };